import React, { Fragment, useEffect, useState } from 'react';

import {
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  makeStyles,
  Select,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  FormControlLabel,
} from '@material-ui/core';

import { Assignment, Visibility, YoutubeSearchedFor } from '@material-ui/icons';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Button from 'components/CustomButtons/Button.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import Checkbox from '@material-ui/core/Checkbox';

import { Toasty, useToasty } from 'hooks/Toasty';
import { wsFindBy, wsGetPdf } from 'services/WService';
import { WithApp } from 'contexts/appContext';
import { currency, nPercent, nInt, formatDate } from 'hooks/Pipe';
import stateLiquidation from 'hooks/stateLiquidation';
import CardHeader from 'components/Card/CardHeader';
import CardIcon from 'components/Card/CardIcon';
import Divider from 'components/Tvendo/Common/Divider';
import PdfModal from 'components/Tvendo/Common/PdfModal';
import RegularButton from 'components/CustomButtons/Button';
import { useModal } from 'hooks/useModal';
import OrderTransactionModal from 'components/Tvendo/Order/OrderTransactionModal';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

const useStyles = makeStyles((theme) => ({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
  paper: {
    padding: theme.spacing(2),
    '& h6': {
      fontSize: 13,
      color: theme.palette.text.secondary,
      marginBottom: 0,
    },
    '& h5': {
      fontSize: 13,
      fontWeight: 400,
      marginTop: 0,
    },
    marginBottom: '15px',
  },
  title: {
    textAlign: 'center',
    fontWeight: 'bold',
    borderBottom: '1px solid #b1b1b1',
  },
  titleCheckBox:{
    marginTop: '5px',
    color: '#b1b1b1 !important',
  },
}));

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: '# Doc', accessor: 'DocEntry', width: 100, align: 'center' },
  { Header: 'Cód. Producto', accessor: 'ItemCode', width: 130 },
  { Header: 'Prom', accessor: 'promotion', width: 100 },
  { Header: 'Nombre Producto', accessor: 'Dscription' },
  { Header: 'Cantidad', accessor: 'Quantity', width: 100, align: 'center' },
  { Header: 'Precio', accessor: 'Price', width: 100, align: 'right' },
  { Header: 'Precio/IGV', accessor: 'PriceAfVAT', width: 120, align: 'right' },
  { Header: 'U/M', accessor: 'unitMsr', width: 120, align: 'center' },
  { Header: 'Cant./Paqu.', accessor: 'NumPerMsr', width: 120, align: 'center' },
  { Header: 'Total Línea', accessor: 'LineTotal', width: 120, align: 'right' },
  { Header: 'Monto IGV', accessor: 'VatSum', width: 100, align: 'right' },
  { Header: 'Total', accessor: 'GTotal', width: 100, align: 'right' },
  { Header: 'Tipo', accessor: 'SWW', width: 100, align: 'center' },
  { Header: 'IGV', accessor: 'VatPrcnt', width: 100, align: 'center' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function SearchDocument(props) {
  const classes = useStyles();
  const [notify, showNotify] = useToasty();

  const [documentTypes, setDocumentTypes] = useState([]);
  const [logModel, setLogModalOpen] = useModal();
  const [search, setSearch] = useState({});
  const [loading, setLoading] = useState(false);
  const [pdfSrc, setPdfSrc] = useState();
  const [comprobantePdfSrc, setComprobantePdfSrc] = useState();
  const [isReferenceChecked, setIsReferenceChecked] = useState(false);

  const [document, setDocument] = useState({ details: [], payments: [], parent: { seller: {} } });

  const handleChange = (e) => {
    setSearch({ ...search, [e.target.name]: e.target.value });
  };
  const handleCheckboxChange = (event) => {
    setIsReferenceChecked(event.target.checked);
  };
  const [dataLoading, setDataLoading] = useState(false);

  async function listDocumentTypes() {
    setDataLoading(true);
    const response = await wsFindBy('base/sunat-document-type/prt', { type: 'search' });
    setDataLoading(false);
    if (response.success) setDocumentTypes(response.data);
  }

  const searchDocuments = async (e) => {
    e.preventDefault();
    setDataLoading(true);
  
    // Se construyen los parámetros de búsqueda dinámicamente
    const searchParams = {
      ReceiptSerie: search.ReceiptSerie,
      ReceiptNumber: search.ReceiptNumber,
      isReferenceChecked: isReferenceChecked,
    };

    // Si el checkbox NO está activo, incluir el ReceiptType
    if (!isReferenceChecked) {
      searchParams.ReceiptType = search.ReceiptType;
    }
    const response = await wsFindBy('sap/find-document', searchParams);
    setDataLoading(false);
    if (response.success) {
      setDocument(response.data);
    } else {
      showNotify(response.message, 'error');
    }
  };

  useEffect(() => {
    listDocumentTypes();
  }, []);

  useEffect(() => {
    setDocument({ details: [], payments: [], parent: { seller: {} } });
  }, [search.ReceiptType]);

  function openGuide() {
    setPdfSrc(
      `sap/find-document/guide-pdf?ReceiptType=${search.ReceiptType}&ReceiptSerie=${search.ReceiptSerie}&ReceiptNumber=${search.ReceiptNumber}`,
    );
  }

  function openComprobante() {
    setComprobantePdfSrc(
      `sap/find-document/comprobante-pdf?ReceiptType=${search.ReceiptType}&ReceiptSerie=${search.ReceiptSerie}&ReceiptNumber=${document.U_SYP_MDCD}`,
    );
  }

  return (
    <>
      <Toasty action={notify} />
      <PdfModal
        title=""
        id="guia"
        src={pdfSrc}
        onClose={() => {
          setPdfSrc(undefined);
        }}
        open={pdfSrc !== undefined}
      />
      <PdfModal
        title=""
        id="comprobante"
        src={comprobantePdfSrc}
        onClose={() => {
          setComprobantePdfSrc(undefined);
        }}
        open={comprobantePdfSrc !== undefined}
      />
      <OrderTransactionModal model={logModel} setOpen={setLogModalOpen} entity="ordm/order" />
      <Card>
        <CardHeader icon>
          <CardIcon color="primary">
            <Assignment />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>Buscar documento {dataLoading && <LoadingSpinner />}</h4>
          <GridContainer>
            {search.ReceiptType === "07" && (
              <GridItem>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isReferenceChecked}
                      onChange={handleCheckboxChange}
                    />
                  }
                  label="Documento de referencia"
                  classes={{ label: classes.titleCheckBox }}
                />
              </GridItem>
            )}
          </GridContainer>
        </CardHeader>
        <CardBody>
          <form onSubmit={searchDocuments}>
            <GridContainer>
              <GridItem xs={12} md={4} lg={2}>
                <FormControl fullWidth margin="normal" size="small" required>
                  <InputLabel>Tipo documento</InputLabel>
                  <Select
                    inputProps={{ name: 'ReceiptType' }}
                    defaultValue=""
                    onChange={handleChange}
                  >
                    {documentTypes.map((item) => (
                      <MenuItem key={item.id} value={item.code}>
                        {item.description}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </GridItem>
              <GridItem xs={12} md={4} lg={2}>
                <TextField
                  label="Serie"
                  fullWidth
                  name="ReceiptSerie"
                  margin="normal"
                  size="small"
                  defaultValue=""
                  onChange={handleChange}
                  required
                />
              </GridItem>
              <GridItem xs={12} md={4} lg={2}>
                <TextField
                  label="Código"
                  fullWidth
                  name="ReceiptNumber"
                  margin="normal"
                  size="small"
                  defaultValue=""
                  onChange={handleChange}
                  required
                />
              </GridItem>
              <GridItem xs={12} md={1} lg={1} style={{ display: 'flex', alignItems: 'flex-end' }}>
                <Button
                  justIcon
                  round
                  size="sm"
                  color={props.themeContext.buttonColor}
                  type="submit"
                >
                  <YoutubeSearchedFor />
                </Button>
                {document.has_guide && (
                  <Button size="sm" color="success" onClick={openGuide} disabled={loading}>
                    Ver guía
                  </Button>
                )}
                {document.DocEntry && (
                  <Button size="sm" color="info" onClick={openComprobante} disabled={loading}>
                    Ver Comprobante
                  </Button>
                )}
                {document.ordmOrder && (
                  <Tooltip title="Logs">
                    <Button
                      size="sm"
                      color="warning"
                      onClick={() => {
                        setLogModalOpen(document.ordmOrder);
                      }}
                    >
                      Ver Logs
                    </Button>
                  </Tooltip>
                )}
              </GridItem>
            </GridContainer>
          </form>

          {document.DocEntry &&
            (document.details ? (
              <Fragment>
                <Divider text="Datos generales" mt={20} mb={20} color="#9c27b0" />
                <HeaderDetail doc={document} type={search.ReceiptType} />

                <Divider text="Forma de pago" mt={20} mb={20} color="#4caf50" />
                <Payments payments={document.payments || document.parent.payments} />

                <Divider text="Detalles" mt={20} mb={20} color="#00acc1" />
                <Details details={document.details} />
              </Fragment>
            ) : (
              <Fragment>
                <Divider text="Documento antiguo" mt={20} mb={20} color="#9c27b0" />
              </Fragment>
            ))}
        </CardBody>
      </Card>
    </>
  );
});

const HeaderDetail = ({ doc, type }) => {
  const classes = useStyles();

  const seller = type === '07' ? doc?.parent?.seller || {} : doc?.seller || {};
  const parent = type === '07' ? doc?.parent || {} : doc || {};
  const hr = type === '07' ? doc?.parent?.sheetDistribution : doc.sheetDistribution; // hoja de reparto

  return (
    <GridContainer>
      <GridItem xs={12} md={3}>
        <GridContainer>
          <GridItem xs={12}>
            <Paper className={classes.paper}>
              <div className={classes.title}>Cliente</div>
              <h6>Código</h6>
              <h5>{doc.CardCode}</h5>
              <h6>Nombre</h6>
              <h5>{doc.CardName}</h5>
              <h6>Dirección</h6>
              <h5>{doc.Address}</h5>
            </Paper>
          </GridItem>
          <GridItem xs={12}>
            <Paper className={classes.paper}>
              <div className={classes.title}>Vendedor</div>
              <h6>Código / Nombre</h6>
              <h5>
                {seller.SlpCode} - {seller.SlpName}
              </h5>
              <h6>DNI</h6>
              <h5>{seller.dni}</h5>
              <h6>Celular</h6>
              <h5>{seller.phone}</h5>
            </Paper>
          </GridItem>
        </GridContainer>
      </GridItem>
      <GridItem xs={12} md={3}>
        <Paper className={classes.paper}>
          <div className={classes.title}>Documento</div>
          <h6>Número</h6>
          <h5>{parent.DocNum}</h5>
          <h6>Documento</h6>
          <h5>{parent.NumAtCard}</h5>
          <h6>Fecha Doc.</h6>
          <h5>{formatDate(parent.TaxDate)}</h5>
          <h6>Fecha Vto.</h6>
          <h5>{formatDate(parent.DocDueDate)}</h5>
          <h6>Fecha Canc.</h6>
          <h5>{formatDate(parent.CancelDate)}</h5>
          <GridContainer>
            <GridItem xs={12} md={6}>
              <h6>Monto</h6>
              <h5>{currency(parent.DocTotal)}</h5>
            </GridItem>
            <GridItem xs={12} md={6}>
              <h6>Mto. IGV</h6>
              <h5>{currency(parent.VatSum)}</h5>
            </GridItem>
            <GridItem xs={12} md={6}>
              <h6>Descuento</h6>
              <h5>{nPercent(parent.DiscPrcnt)}</h5>
            </GridItem>
          </GridContainer>
        </Paper>
      </GridItem>

      {type === '07' ? (
        <GridItem xs={12} md={3}>
          <Paper className={classes.paper}>
            <div className={classes.title}>Nota de crédito</div>
            <h6>Documento</h6>
            <h5>{doc.NumAtCard}</h5>
            <h6>Fecha Doc.</h6>
            <h5>{formatDate(doc.TaxDate)}</h5>
            <h6>Fecha Vto.</h6>
            <h5>{formatDate(doc.DocDueDate)}</h5>
            <h6>Fecha Canc.</h6>
            <h5>{formatDate(doc.CancelDate)}</h5>
            <GridContainer>
              <GridItem xs={12} md={6}>
                <h6>Monto</h6>
                <h5>{currency(doc.DocTotal)}</h5>
              </GridItem>
              <GridItem xs={12} md={6}>
                <h6>Mto. IGV</h6>
                <h5>{currency(doc.VatSum)}</h5>
              </GridItem>
              <GridItem xs={12} md={6}>
                <h6>Descuento</h6>
                <h5>{nPercent(doc.DiscPrcnt)}</h5>
              </GridItem>
            </GridContainer>
          </Paper>
        </GridItem>
      ) : undefined}

      <GridItem xs={12} md={3}>
        <Paper className={classes.paper}>
          <div className={classes.title}>Hoja de distribución</div>
          {hr ? (
            <>
              <h6>Nro Hoja</h6>
              <h5>
                {hr.id}
              </h5>
              <h6>Código / Nombre J. mercadería</h6>
              <h5>
                {hr.inventory_manager_code} - {hr.inventory_manager_name}
              </h5>
              <h6>Nombre J. Reparto</h6>
              <h5>
                {hr.manager_code} - {hr.manager_name}
              </h5>
              <GridContainer>
                <GridItem xs={12} md={6}>
                  <h6>Licencia</h6>
                  <h5>{hr.manager_license}</h5>
                </GridItem>
                <GridItem xs={12} md={6}>
                  <h6>Zona</h6>
                  <h5>{hr.origin_zone_description}</h5>
                </GridItem>
                <GridItem xs={12} md={6}>
                  <h6>Almacén</h6>
                  <h5>{hr.logi_warehouse_name}</h5>
                </GridItem>
                <GridItem xs={12} md={6}>
                  <h6>Estado</h6>
                  <h5>{stateLiquidation(hr.state)}</h5>
                </GridItem>
                <GridItem xs={12} md={6}>
                  <h6>Fecha liquidación</h6>
                  <h5>{formatDate(hr.liquidate_date)}</h5>
                </GridItem>
                <GridItem xs={12} md={6}>
                  <h6>Fecha cierre</h6>
                  <h5>{formatDate(hr.close_date)}</h5>
                </GridItem>
                <GridItem xs={12} md={6}>
                  <h6>Monto</h6>
                  <h5>{currency(hr.SumApplied)}</h5>
                </GridItem>
                <GridItem xs={12} md={6}>
                  <h6>Total</h6>
                  <h5>{currency(hr.amount)}</h5>
                </GridItem>
              </GridContainer>
            </>
          ) : (
            <h5>No hay hoja de distribución</h5>
          )}
        </Paper>
      </GridItem>
    </GridContainer>
  );
};

const Payments = ({ payments }) => (
  <TableContainer component={Paper}>
    <Table style={{ minWidth: 650 }} size="small" aria-label="medos de pago">
      <TableHead>
        <TableRow>
          <TableCell>Tipo pago</TableCell>
          <TableCell>Fecha</TableCell>
          <TableCell>Pagado</TableCell>
          <TableCell>Total</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {payments.map((item, i) => (
          <TableRow key={i}>
            <TableCell>{item.TipoPago}</TableCell>
            <TableCell>{formatDate(item.TaxDate, 'F')}</TableCell>
            <TableCell>{currency(item.SumApplied)}</TableCell>
            <TableCell>{currency(item.DocTotal)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

const Details = ({ details }) => {
  return (
    <ReactTable
      excelName="Familias"
      defaultWidth={1800}
      columns={columns}
      data={details.map((item, i) => {
        return {
          num: i + 1,
          DocEntry: item.DocEntry,
          LineStatus: item.LineStatus,
          ItemCode: item.ItemCode,
          promotion:
            item.prom_promotion_id !== null ? (
              <Fragment>
                <RegularButton
                  justIcon
                  color="primary"
                  round
                  simple
                  onClick={() => {
                    window.open(
                      '/admin/articulos/operaciones/promociones/' + item.prom_promotion_id,
                      '_blank',
                    );
                  }}
                >
                  <Visibility />
                </RegularButton>
                {item.prom_promotion_id}
              </Fragment>
            ) : (
              ''
            ),
          Dscription: item.Dscription,
          Quantity: nInt(item.Quantity),
          Price: currency(item.Price),
          PriceAfVAT: currency(item.PriceAfVAT),
          unitMsr: item.unitMsr,
          NumPerMsr: item.NumPerMsr,
          LineTotal: currency(item.LineTotal),
          VatSum: currency(item.VatSum),
          GTotal: currency(item.GTotal),
          SWW: item.SWW === 'B' ? 'Bonificación' : 'Normal',
          VatPrcnt: nPercent(item.VatPrcnt),
        };
      })}
    />
  );
};
